import { StyleSheet, View } from "react-native";
import CustomText from "../../../components/common/general/CustomText/CustomText";
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface DashboardDataContainerProps {
  newSubmissionsToday: number;
  assignmentsAndAssessmentsToGrade: number;
  isLoading: boolean;
}

const DashboardDataContainer: React.FC<DashboardDataContainerProps> = ({
  newSubmissionsToday,
  assignmentsAndAssessmentsToGrade,
  isLoading,
}) => {
  return (
    <View style={styles.container}>
      {isLoading ? (
        <View style={{ width: "100%", maxWidth: 1347 }}>
          <Skeleton height={106} width="100%" borderRadius={20} />
        </View>
      ) : (
        <>
          <View style={styles.topTile}>
            <CustomText
              style={{ fontSize: 36, color: "#101828", marginBottom: 16 }}
              weight="ultraBold"
              text={assignmentsAndAssessmentsToGrade}
              useTranslationText={false}
            />
            <CustomText style={styles.topText} text="Assignments & Assessments to Grade" useTranslationText={false} />
          </View>
          <View style={styles.topTile}>
            <CustomText
              style={{ fontSize: 36, color: "#101828", marginBottom: 16 }}
              weight="ultraBold"
              text={newSubmissionsToday}
              useTranslationText={false}
            />
            <CustomText style={styles.topText} text="New Submissions Today" useTranslationText={false} />
          </View>
        </>
      )}
    </View>
  );
};

export default DashboardDataContainer;

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: 48,
    gap: 24,
    width: "100%",
  },
  topTile: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "flex-start",
    borderColor: "#EAECF0",
    borderWidth: 1,
    borderRadius: 20,
    padding: 20,
  },
  topText: {
    fontSize: 14,
    fontWeight: 500,
    paddingBottom: 8,
    color: "#667085",
  },
});
